import http from "../common/http-common";

export async function doLogin(data) {
  return http.post("/login", data);
}
